import useSWR from 'swr';

import { Modules } from '~/data/modules';
import { useAppModules } from '~/scenes/AppModules/useAppModules';
import { MyWorkspaceUserSettingsKey } from '~/scenes/MyWorkspace/userSettings';
import { PreferencesApiClient } from '~/services/Http';

export const useGetUserPreferencesData = () => {
  const preferencesKey = MyWorkspaceUserSettingsKey;

  const { data, isLoading, error } = useSWR(
    ['userPreferences', preferencesKey],
    () =>
      PreferencesApiClient.getPreferences([preferencesKey]).then(
        (r) => r.data[preferencesKey],
      ),
  );

  return {
    data,
    isLoading,
    error,
  };
};

export const useUserHomepageSetting = () => {
  const { isModuleActive } = useAppModules();
  const { isLoading, data } = useGetUserPreferencesData();

  const useWorkspaceAsHomepage = isModuleActive(Modules.WORKSPACE)
    ? data?.useWorkspaceAsHomepage ?? false
    : false;

  return {
    isLoading,
    hasData: !!data,
    useWorkspaceAsHomepage,
  };
};
